import { useEffect, useState, useCallback, useContext } from "react";
import { ToastContainer } from "react-toastify";
import { Route } from "react-router-dom";
import { formatUnits } from "@ethersproject/units";

import "react-toastify/dist/ReactToastify.css";
import { useStakingContract, useTokenContract } from "./ConnectivityAss/hooks";
import Loader from "./components/loader";
import "./App.css";
import { AppContext } from "./utils";
import { Footer, NavBar, StakingBanner, Calculator } from "./components";

function App() {
  const { account, signer } = useContext(AppContext);
  const stakingContract = useStakingContract(signer);
  const tokenContract = useTokenContract(signer);

  const [loading, setloading] = useState(false);
  const [totalStaked, setTotalStaked] = useState(0);
  const [solarValueStaked, setsolarValueStaked] = useState(0);
  const [apr, setApr] = useState(0);
  const [stakeDetails, setStakeDetails] = useState([]);

  const init = useCallback(async () => {
    try {
      setloading(true);
      const dec = await tokenContract.decimals();
      const apr = await stakingContract.apr();
      const totalStaked = await stakingContract.totalStakedTokens();

      if (account) {
        const { stakeCount } = await stakingContract.users(account);

        if (+stakeCount > 0) {
          let arr = [];
          for (let i = 1; i <= +stakeCount; i++) {
            const { amount, reward, startTime, endTime, withdrawn } =
              await stakingContract.getStakeInfo(account, i.toString());

            const myObj = {
              stakedAmount: +formatUnits(amount.toString(), +dec),
              reward: +formatUnits(reward.toString(), +dec),
              startTime: +startTime,
              endtime: +endTime,
              withdraw: withdrawn,
            };
            arr.push(myObj);
          }
          setStakeDetails([...arr]);
        }

        setloading(false);
      }
      setTotalStaked(+formatUnits(totalStaked.toString(), +dec));
      setApr(+apr / 100);
      setloading(false);
    } catch (error) {
      console.log(error);
      setloading(false);
    }
  }, [account, stakingContract, tokenContract]);
  useEffect(() => {
    init();
  }, [init]);

  return (
    <div className="App">
      <ToastContainer />
      <Loader loading={loading} />
      <NavBar />
      <Route exact path="/">
        <StakingBanner
          apr={apr}
          solarStaked={totalStaked}
          solarValueStaked={solarValueStaked}
        />
        <Calculator apr={apr} init={init} stakeDetails={stakeDetails} />
      </Route>
      <Footer />
    </div>
  );
}

export default App;
